/* Studio de modèle — EM-03 (Bible §50.2 · MER-103).
   Approved variables only: an unescaped or unknown variable blocks publish,
   stated as the reason rather than as a silent disabled button. Preview is
   delivered parity — the same shell the inbox receives. */
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button, Field, Input, KV, Note } from '@/ui'
import { Retour } from './parts'

const AUTORISEES = '{first_name} {merchant} {gift} {date} {location_scope} {conditions_url} {useful_action_url}'
const VUES = ['Desktop', 'Mobile', 'Texte brut'] as const

export default function Studio() {
  const [params] = useSearchParams()
  const [objet, setObjet] = useState('Votre cadeau chez {merchant}')
  const [preheader, setPreheader] = useState('{gift} — à utiliser avant le {date}')
  const [vue, setVue] = useState<string>(VUES[0])

  /* the frame’s blocked-publish case: an unapproved variable is present.
     ?etat=bloque renders it as drawn without waiting for the merchant to
     type one — the frame shows the rule, not a clean form. */
  const interdite = params.get('etat') === 'bloque' || /\{reward_cost\}/.test(objet + preheader)
    ? '{reward_cost}' : null

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 780 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Studio — «&nbsp;Votre cadeau&nbsp;» v5</h2>
        <span className="tabs" style={{ marginLeft: 'auto' }}>
          {VUES.map(v => (
            <button key={v} type="button" className={'tab' + (vue === v ? ' on' : '')}
              onClick={() => setVue(v)}>{v}</button>
          ))}
        </span>
      </div>

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: '1fr 1fr' }}>
        <Field label="Objet">
          {id => <Input id={id} value={objet} onChange={e => setObjet(e.currentTarget.value)} />}
        </Field>
        <Field label="Pré-en-tête">
          {id => <Input id={id} value={preheader} onChange={e => setPreheader(e.currentTarget.value)} />}
        </Field>
      </div>

      <KV rows={[['Variables autorisées', <span key="v" className="t-code">{AUTORISEES}</span>]]} />

      {interdite && (
        <Note tone="crit">
          ✕ {interdite} n’est pas une variable autorisée — publication bloquée tant qu’un champ
          manquant ou interdit subsiste.
        </Note>
      )}

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="quiet">Aperçu données réelles</Button>
        <Button size="sm" variant="quiet">M’envoyer un test</Button>
        <Button size="sm" variant="primary" disabled={interdite !== null}>Publier le modèle</Button>
      </div>
    </div>
  )
}
